import React from 'react';
import styles from '../BetSlip.module.scss';
import { BET_PLACEMENT_SUBMIT_BUTTON_TYPES, BET_SLIP_TABS } from '../../../constants/defaultValues';
import { roundNumber } from '../../../utils/formatDecimal';
import { useSelector } from 'react-redux';
import betSlipCalculator from '../../../utils/betSlipCalculator';
import { getTranslation } from '../../../utils/translation';
import { isVoucherMode } from '../../../utils/helpers';

const Footer = props => {
    const validations = useSelector(state => state.betSlip.validations);
    const activeTab = useSelector(state => state.betSlip.activeTab);
    const betLines = useSelector(state => state.betSlip.betLines);
    const stakes = useSelector(state => state.betSlip.stakes);
    const selectedCombinations = useSelector(state => state.betSlip.selectedCombinations);
    const isTicketSubmitting = useSelector(state => state.betSlip.isTicketSubmitting);
    const producerStatuses = useSelector(state => state.feed.producerStatuses);
    const cashierInfo = useSelector(state => state.auth.cashierInfo);
    const { isSocketConnected } = useSelector(state => state.socket);
    const isMaxStakeLoading = useSelector(state => state.betSlip.isMaxStakeLoading);

    const { submitButtonType } = props;
    const { potentialPayout } = betSlipCalculator.calculateTicketDetails({
        betLines,
        activeTab,
        stakes,
        selectedCombinations,
    });

    const isPlaceBetDisabled = () => {
        let hasError = false;

        if (activeTab === BET_SLIP_TABS.single.id) {
            hasError = validations.single.length > 0 || validations.common.length > 0;
        } else if (activeTab === BET_SLIP_TABS.combo.id) {
            hasError = validations.combo.length > 0 || validations.common.length > 0;
        } else if (activeTab === BET_SLIP_TABS.system.id) {
            hasError = validations.system.length > 0 || validations.common.length > 0;
        }

        const hasClosedBet = betLines.some(b => b.closed);
        const isCombinationsSelected =
            activeTab !== BET_SLIP_TABS.system.id || selectedCombinations.length > 0;
        const isPreMatchProducerDown =
            producerStatuses.isPreMatchDown && betLines.some(b => !b.isLive);
        const isLiveProducerDown = producerStatuses.isLiveDown && betLines.some(b => b.isLive);

        return (
            hasError ||
            hasClosedBet ||
            !isCombinationsSelected ||
            isPreMatchProducerDown ||
            isLiveProducerDown
        );
    };

    const onPlaceBetClick = () => {
        if (isPlaceBetDisabled() || isTicketSubmitting) return;

        props.onPlaceBetClick();
    };

    return (
        submitButtonType === BET_PLACEMENT_SUBMIT_BUTTON_TYPES.submit && (
            <div className={styles.betSlipAction}>
                <div className='total'>
                    <p className={styles.totalText}>
                        {getTranslation('betSlip.placeBets.potentialPayout')}
                    </p>
                    <span className={styles.totalPrice}>{roundNumber(potentialPayout, 2)} AZN</span>
                </div>
                <button
                    className={`${styles.betSlipButton} ${styles.red}`}
                    disabled={
                        isPlaceBetDisabled() ||
                        isTicketSubmitting ||
                        !isSocketConnected ||
                        isMaxStakeLoading
                    }
                    onClick={onPlaceBetClick}
                >
                    {isVoucherMode(cashierInfo)
                        ? getTranslation('betSlip.actions.placeBets')
                        : getTranslation('betSlip.actions.bookBet')}
                </button>
            </div>
        )
    );
};

export default Footer;
